<template>
    <div class="orders-view">
      <!-- Top bar -->
      <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
      </div>
      <div class="top-spacer"></div>
  
      <!-- Header -->
      <div class="panel-head">
        <div class="head-left">
          <h3>Búsqueda</h3>
        </div>
        <img src="@/assets/filtros.png" alt="filtros" class="head-icon"/>
      </div>
  
      <!-- FILTERS (ultra compact, one row per filter) -->
      <form class="filters-card" @submit.prevent="queryOrders">
        <!-- Nota ID -->
        <div class="row">
          <label for="note_ident">Identificador de la nota</label>
          <input id="note_ident" type="text" v-model="noteIdent" placeholder="Inicio" />
          <span class="sep">al</span>
          <input id="note_ident_end" type="text" v-model="noteIdentEnd" placeholder="Fin" />
        </div>
        
        <!-- Fechas -->
        <div class="row">
          <label>Fecha de solicitud</label>
          <input type="date" v-model="startDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
          <span class="sep">al</span>
          <input type="date" v-model="endDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
        </div>
  
        <!-- Cliente (con sugerencias) -->
        <div class="row row-rel">
          <label for="client_name">Cliente</label>
          <input
            id="client_name"
            type="text"
            v-model="clientName"
            placeholder="Escriba para buscar"
            @input="filterSuggestions"
            autocomplete="off"
          />
          <div class="cell span-2"></div>
          <ul v-if="filteredClients.length" class="suggestions">
            <li v-for="(client, index) in filteredClients" :key="index" @click="selectClient(client)">
              {{ client.client_ident + ' - ' + client.client_name }}
            </li>
          </ul>
        </div>
  
        <!-- Expediente -->
        <div class="row">
          <label for="file">Expediente</label>
          <input id="file" type="text" v-model="file" placeholder="Número de expediente" />
          <div class="cell span-2"></div>
        </div>

        <!-- Placa -->
        <div class="row">
          <label for="plate">Placa</label>
          <input id="plate" type="text" v-model="plate" placeholder="ABC-123" />
          <div class="cell span-2"></div>
        </div>
  
        <!-- Serie -->
        <div class="row">
          <label for="engine">Serie</label>
          <input id="engine" type="text" v-model="engine" placeholder="Serie / motor" />
          <div class="cell span-2"></div>
        </div>

        <!-- Marca / Submarca -->
        <div class="row">
          <label for="vehicle_brand">Marca</label>
          <select id="vehicle_brand" class="form-select" v-model="SelectedBrand" @change="FetchFilteredSubBrands" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
            <option v-for="(brandPk, brandName) in brands" :key="brandPk" :value="brandPk">
              {{ brandName }}
            </option>
          </select>
          <span class="sep"></span>
          <select id="vehicle_subbrand" class="form-select"
                  v-model="SelectedSubBrand"
                  :disabled="blockEdit || subBrandLoading"
                  :class="{ 'grayed-out': blockEdit, 'sub-brand-loading-grayed-out': subBrandLoading }">
            <option v-for="(subId, subLabel) in sub_brands" :key="subId" :value="subId">
              {{ subLabel }}
            </option>
          </select>
        </div>
  
        <!-- Operador -->
        <div class="row">
          <label for="operator">Operador</label>
          <input id="operator" type="text" v-model="operator" placeholder="Nombre o ID" />
          <div class="cell span-2"></div>
        </div>
  
        <!-- Unidad -->
        <div class="row">
          <label for="unit">Unidad</label>
          <input id="unit" type="text" v-model="unit" placeholder="# Económico" />
          <div class="cell span-2"></div>
        </div>

        
        <div class="row">
          <label for="sucursal">Sucursal</label>
          <select id="sucursal" v-model="sucursal" class="form-select">
            <option value="" disabled selected>Seleccione</option>
            <option v-for="opt in $catalogs.sucursales" :key="opt" :value="opt">{{ opt }}</option>
          </select>
          <div class="cell span-2"></div>
        </div>

        
        <!-- Tipo de servicio -->
        <div class="row">
          <label for="note_type">Tipo de servicio</label>
          <select id="note_type" v-model="noteType" class="form-select">
            <option value="" disabled selected>Seleccione</option>
            <option value="2">Remolque</option>
            <option value="1">Auxilio vial</option>
            <option value="4">Lote</option>
            <option value="3">Montacargas</option>
            <option value="5">Industrial</option>
          </select>
          <div class="cell span-2"></div>
        </div>
  
        <!-- Origen -->
        <div class="row">
          <label for="origin">Origen</label>
          <input id="origin" type="text" v-model="origin" placeholder="Colonia, ciudad, estado" />
          <div class="cell span-2"></div>
        </div>
  
        <!-- Destino -->
        <div class="row">
          <label for="destination">Destino</label>
          <input id="destination" type="text" v-model="destination" placeholder="Colonia, ciudad, estado" />
          <div class="cell span-2"></div>
        </div>

        
        <!-- Capturista -->
        <div class="row">
          <label for="clerk">Capturista</label>
          <input id="clerk" type="text" v-model="clerk" placeholder="Apellido, Nombre" />
          <div class="cell span-2"></div>
        </div>
  
        <!-- Estatus -->
        <div class="row">
          <label>Estatus</label>
          <div class="chips">
            <label class="chip">
              <input type="checkbox" id="isActive" v-model="isActive" />
              <span>Activo</span>
            </label>
            <label class="chip">
              <input type="checkbox" id="isAssigned" v-model="isAssigned" />
              <span>Asignada</span>
            </label>
            <label class="chip">
              <input type="checkbox" id="isProgrammed" v-model="isProgrammed" />
              <span>Pendiente</span>
            </label>
            <label class="chip">
              <input type="checkbox" id="isCanceled" v-model="isCanceled" />
              <span>Cancelado</span>
            </label>
            <label class="chip">
              <input type="checkbox" id="isCompleted" v-model="isCompleted" />
              <span>Completado</span>
            </label>
            <!-- <label class="chip">
              <input type="checkbox" id="pendingBilling" v-model="pendingBilling" />
              <span>Pendiente por facturar</span>
            </label> -->
            <label class="chip">
              <input type="checkbox" id="isInLot" v-model="isInLot" />
              <span>En lote</span>
            </label>
          </div>
        </div>
  
        <!-- Facturación -->
        <div class="row">
          <label for="pendingBilling">Facturación</label>
          <div class="chips">
            <label class="chip">
              <input type="checkbox" id="pendingBilling" v-model="pendingBilling" />
              <span>Pendiente por facturar</span>
            </label>
          </div>
        </div>
  
        <!-- Tipo de cliente -->
        <div class="row">
          <label for="client_type">Tipo de cliente</label>
          <select id="client_type" v-model="clientType" class="form-select">
            <option value="">Todos</option>
            <option value="Asistencia">Asistencia</option>
            <option value="Aseguradora">Aseguradora</option>
            <option value="Cliente en general">Cliente en general</option>
          </select>
          <div class="cell span-2"></div>
        </div>
  
        <!-- Actions -->
        <div class="row actions">
          <div class="cell span-4">
            <button type="submit" class="btn-primary" @click="queryOrders">Aplicar filtros</button>
          </div>
        </div>
    </form>
  
      <!-- Results -->
      <section class="results-card" id="results-section">
        <div class="results-head">
          <h2>Resultados: {{ totalCount }}</h2>
        </div>
  
        <div class="table-scroll">
          <table class="table">
            <thead>
              <tr>
                <th @click="toggleSort('note_number')">
                  ID
                  <span v-if="isSorted('note_number')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
                  <span v-else>↕</span>
                </th>
                <th @click="toggleSort('request_time')">
                  Fecha y hora de solicitud
                  <span v-if="isSorted('request_time')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
                  <span v-else>↕</span>
                </th>
                <th @click="toggleSort('client')">
                  Cliente
                  <span v-if="isSorted('client')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
                  <span v-else>↕</span>
                </th>
                <th>Origen</th>
                <th>Destino</th>
                <th>Hora de inicio</th>
                <th>Hora de contacto</th>
                <th @click="toggleSort('unit')">
                  Unidad
                  <span v-if="isSorted('unit')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
                  <span v-else>↕</span>
                </th>
                <th @click="toggleSort('operator_employee_ident')">
                  Operador
                  <span v-if="isSorted('operator_employee_ident')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
                  <span v-else>↕</span>
                </th>
                <th @click="toggleSort('file_number')">
                  Expediente
                  <span v-if="isSorted('file_number')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
                  <span v-else>↕</span>
                </th>
                <th @click="toggleSort('clerk')">
                  Capturista
                  <span v-if="isSorted('clerk')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
                  <span v-else>↕</span>
                </th>
                <th @click="toggleSort('type')">
                  Tipo
                  <span v-if="isSorted('type')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
                  <span v-else>↕</span>
                </th>
                <th @click="toggleSort('status')">
                  Estatus
                  <span v-if="isSorted('status')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
                  <span v-else>↕</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(order, index) in queriedOrders"
                :key="index"
                @click="viewNoteDetails(order.type, order.note_ident)"
                class="row-click"
              >
                <td>
                  <span class="badge badge-id" @click.stop="viewNoteDetails(order.type, order.note_ident)">
                    {{ order.note_number }}
                  </span>
                </td>
                <td>
                  <b>Fecha:</b>
                  {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                  &nbsp;<b>Hora:</b> {{ order.request_time.substring(11,16) }}
                </td>
                <td>{{ order.client }}</td>
                <td>{{ order.source.neighborhood }}, {{ order.source.city }}, {{ order.source.state }}</td>
                <td>{{ order.destination.neighborhood }}, {{ order.destination.city }}, {{ order.destination.state }}</td>
                <td>{{ order.start_time.substring(11,16) }}</td>
                <td>{{ order.contact_time.substring(11,16) }}</td>
                <td>{{ order.unit_id }}</td>
                <td>{{ order.operator_employee_ident }}</td>
                <td>{{ order.file_number }}</td>
                <td>{{ order.data_entry_clerk }}</td>
                <td>{{ order.type }}</td>
                <td>
                  <span
                    v-if="order.status === 'Activo'"
                    class="badge badge-success"
                  >Activo</span>
                  <span
                    v-else-if="order.status === 'Asignada'"
                    class="badge badge-assign"
                  >Asignada</span>
                  <span
                    v-else-if="order.status === 'Cancelado'"
                    class="badge badge-danger"
                  >Cancelado</span>
                  <span
                    v-else-if="order.status === 'Programado'"
                    class="badge badge-pending"
                  >Pendiente</span>
                  <span
                    v-else-if="order.status === 'Completado'"
                    class="badge badge-info"
                  >Completado</span>
                  <span
                    v-else-if="order.status === 'Facturada'"
                    class="badge badge-neutral"
                  >Facturada</span>
                  <span v-else class="badge">{{ order.status }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <!-- Pagination -->
        <div class="pagination">
          <button @click="prevPage" :disabled="currentPage === 1" class="pg-btn" aria-label="Página anterior">
            <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
          </button>
          <span
            v-for="pageNumber in TotalPages"
            :key="pageNumber"
            @click="goToPage(pageNumber)"
            :class="['pg-num', { active: pageNumber === currentPage }]"
          >
            {{ pageNumber }}
          </span>
          <button @click="nextPage" :disabled="currentPage >= TotalPages" class="pg-btn" aria-label="Página siguiente">
            <img src="@/assets/angulo-derecho.png" alt="Next Page" />
          </button>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import Swal from 'sweetalert2';
  import Fuse from 'fuse.js';
  
  export default {
    name: "OrdersTableView",
    data() {
      return {
        // filters
        noteIdent: '',
        noteIdentEnd: '',
        startDate: '',
        endDate: '',
        clientName: '',
        clientIdent: '',
        origin: '',
        destination: '',
        sucursal: '',
        unit: '',
        operator: '',
        file: '',
        clerk: '',
        plate: '',
        clientType: '',
        engine: '',
        noteType: '',
        isActive: '',
        isAssigned: '',
        isCanceled: '',
        isCompleted: '',
        isProgrammed: '',
        isInLot: '',
        pendingBilling: '',
        blockEdit: false,
        SelectedBrand: '',
        SelectedSubBrand: '',
        brands: {},        // { brandName: pk }
        sub_brands: {},    // { subLabel: subId }
        subBrandLoading: false,
  
        // results & paging
        queriedOrders: [],
        currentPage: 1,
        pageSize: 20,
        nOrders: 1,
        StatusCounts: {
          Activo: 1, Cancelado: 1, Programado: 1, Completado: 1, Asignada: 1, Facturada: 1
        },
        totalCount: 0,
  
        // client suggestions
        clients: [],
        filteredClients: [],
        fuse: null,
        highlightedIndex: -1,
        sortState: { by: 'request_time', dir: 'desc' }
      };
    },
    computed: {
      effectiveEndDate() {
        return this.endDate || this.startDate;
      },
      PaginatedOrders() {
        return this.queriedOrders;
      },
      TotalPages() {
        return Math.ceil(
          (this.StatusCounts.Activo + this.StatusCounts.Asignada + this.StatusCounts.Programado + this.StatusCounts.Completado + this.StatusCounts.Facturada) / this.pageSize
        );
      },
    },
    methods: {
    async FetchBrands() {
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const { data } = await axios.get(`${apiDirectory}/get-brands`);
          const brandsDict = {};
          // map to {brandName: pk}
          data.forEach(b => { brandsDict[b.brand] = b.pk; });
          this.brands = brandsDict;
        } catch (error) {
          console.error("Failed to fetch brands", error);
          const status = error?.response?.status;
          if (status === 400) {
            Swal.fire('Error', 'Hubo un problema con la solicitud. Inténtalo nuevamente.\nSi el problema persiste, contacte a su administrador.', 'error');
          } else {
            Swal.fire('Error', 'Ocurrió un error desconocido. Inténtalo nuevamente.\nSi el problema persiste, contacte a su administrador.', 'error');
          }
        }
      },
  
      async FetchFilteredSubBrands(event){
        this.subBrandLoading = true;
        const selectedBrandPk = event.target.value;
        if (selectedBrandPk !== this.SelectedBrand) this.SelectedSubBrand = null;
  
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const { data } = await axios.post(`${apiDirectory}/get-filtered-sub-brands`, { brand_id: selectedBrandPk });
          const subBrandsDict = {};
          const classes = {1:'A', 2:'B', 3:'C', 4:'D'};
          data.forEach(sb => {
            subBrandsDict[`${sb.sub_brand} -- Clase: ${classes[sb.required_unit_type]}`] = sb.id;
          });
          this.sub_brands = subBrandsDict;
        } catch (error) {
          console.error("Failed to fetch sub-brands", error);
          const status = error?.response?.status;
          if (status === 400) {
            Swal.fire('Error', 'Hubo un problema con la solicitud. Inténtalo nuevamente.\nSi el problema persiste, contacte a su administrador.', 'error');
          } else {
            Swal.fire('Error', 'Ocurrió un error desconocido. Inténtalo nuevamente.\nSi el problema persiste, contacte a su administrador.', 'error');
          }
        } finally {
          this.subBrandLoading = false;
        }
      },
  
      formatToDatetime(date, time) {
        if (!date) return '';
        return `${date}T${time}`;
      },
      async fetchClients() {
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.get(`${apiDirectory}/get-privileged-clients`);
          this.clients = response.data;
          this.initializeFuse();
        } catch (error) {
          console.error('Error fetching clients:', error);
        }
      },
      initializeFuse() {
        const options = {
          keys: ['client_name'],
          threshold: 0.3,
          ignoreLocation: true,
          includeScore: false,
        };
        this.fuse = new Fuse(this.clients, options);
      },
      filterSuggestions() {
        const searchTerm = (this.clientName || '').toLowerCase().trim();
        if (!searchTerm) { this.filteredClients = []; this.highlightedIndex = -1; return; }
        this.filteredClients = this.clients.filter(c =>
          (c.client_name || '').toLowerCase().includes(searchTerm) ||
          (c.client_ident || '').toLowerCase().includes(searchTerm)
        );
        this.highlightedIndex = -1;
      },
      selectClient(client) {
        this.clientName = client.client_name;
        this.clientIdent = client.client_ident;
        this.filteredClients = [];
      },
      orderingParam() {
        const { by, dir } = this.sortState || {};
        if (!by) return '';
        return (dir === 'desc' ? '-' : '') + by;
      },
      isSorted(field) {
        return this.sortState?.by === field;
      },
      toggleSort(field) {
        if (!this.sortState) this.sortState = { by: field, dir: 'asc' };
        else if (this.sortState.by === field) {
          this.sortState.dir = this.sortState.dir === 'asc' ? 'desc' : 'asc';
        } else {
          this.sortState.by = field;
          this.sortState.dir = 'asc';
        }
        this.currentPage = 1;
        this.queryOrders();
      },
      backMainPanel() {
        window.location.href = '/main-panel';
      },
      viewNoteDetails(notetype, noteID) {
        this.$router.push({ name: 'EditNote', params: { notetype, noteID } });
      },
      goToPage(pageNumber) {
        this.currentPage = pageNumber;
        this.queryOrders(this.currentPage);
      },
      nextPage() {
        if (this.currentPage < this.TotalPages) this.currentPage++;
        this.queryOrders(this.currentPage);
      },
      prevPage() {
        if (this.currentPage > 1) this.currentPage--;
        this.queryOrders(this.currentPage);
      },
      async fetchStatistics() {
        const payload = {
          note_ident: this.noteIdent,
          note_ident_end: this.noteIdentEnd,
          start_date: this.formatToDatetime(this.startDate, '00:00'),
          end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
          client_name: this.clientName || "",
          origin: this.origin,
          destination: this.destination,
          unit: this.unit,
          operator: this.operator,
          file: this.file,
          clerk: this.clerk,
          plate: this.plate,
          client_type: this.clientType,
          engine: this.engine,
          is_active: this.isActive,
          is_completed: this.isCompleted,
          is_assigned: this.isAssigned,
          is_canceled: this.isCanceled,
          is_programmed: this.isProgrammed,
          is_in_lot: this.isInLot,
          note_type: this.noteType,
          pending_billing: this.pendingBilling,
          client_ident: this.clientName === "" ? "" : this.clientIdent,
          sub_brand: this.SelectedSubBrand,
          sucursal: this.sucursal,
        };
        const apiDirectory = process.env.API_DIRECTORY;
        try {
          const response = await axios.post(`${apiDirectory}/get-global-filtered-statistics`, payload);
          const statusDict = { 1: "Activo", 2: "Cancelado", 3: "Programado", 4: "Completado", 5: "Asignada", 6: "Facturada" };
          let statusCounts = { Activo:0, Cancelado:0, Programado:0, Completado:0, Asignada:0, Facturada:0 };
          this.totalCount = 0;
          (response.data || []).forEach(item => {
            const name = statusDict[item.status];
            const count = item.count;
            statusCounts[name] = count;
            this.totalCount += count;
          });
          this.StatusCounts = statusCounts;
        } catch (error) {
          console.error("There was an error fetching the statistics", error);
        }
      },
      async queryOrders() {
        this.fetchStatistics();
        const payload = {
          note_ident: this.noteIdent,
          note_ident_end: this.noteIdentEnd,
          start_date: this.formatToDatetime(this.startDate, '00:00'),
          end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
          client_name: this.clientName || "",
          origin: this.origin,
          destination: this.destination,
          unit: this.unit,
          operator: this.operator,
          file: this.file,
          clerk: this.clerk,
          plate: this.plate,
          client_type: this.clientType,
          engine: this.engine,
          is_active: this.isActive,
          is_completed: this.isCompleted,
          is_assigned: this.isAssigned,
          is_canceled: this.isCanceled,
          is_programmed: this.isProgrammed,
          is_in_lot: this.isInLot,
          note_type: this.noteType,
          pending_billing: this.pendingBilling,
          client_ident: this.clientName === "" ? "" : this.clientIdent,
          sub_brand: this.SelectedSubBrand,
          sucursal: this.sucursal
        };
        const ordering = this.orderingParam();
        const orderingQS = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.post(
            `${apiDirectory}/get-global-filtered-orders?page=${this.currentPage}&page_size=${this.pageSize}${orderingQS}`,
            payload
          );
          const results = (response.data && response.data.results) ? response.data.results : [];
          results.forEach(order => {
            if (!('contact_time' in order) || order.contact_time === null) order.contact_time = '';
            if (!('start_time' in order) || order.start_time === null) order.start_time = '';
            if (!('unit_id' in order) || order.unit_id === null) order.unit_id = 'N/A';
            if (!('operator_first_name' in order) || order.operator_first_name === null) order.operator_first_name = 'N/A';
            if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) order.operator_employee_ident = 'N/A';
          });
          this.queriedOrders = results;
          this.$nextTick(() => {
  const el = document.getElementById('results-section');
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});
        } catch (error) {
          const errorMessage = error.response ? error.response.data.error : error.message;
          Swal.fire({ icon: 'error', title: 'Error Generando Reporte', text: errorMessage });
        }
      }
    },
    mounted() {
      this.fetchClients();
      this.FetchBrands();
    }
  };
  </script>

  <style>

:root {
    --brand: #ffc434;
    --brand-600: #e6b12e;
    --bg: #f7f7f8;
    --card: #ffffff;
    --border: #e8e8ea;
    --muted: #70737a;
    --text: #1f2328;
  
    --success: #28a745;
    --assign: #9be15d; /* lime-green */
    --danger: #e5484d;
    --pending: #7b61ff; /* indigo */
    --info: #1976d2;
    --neutral: #6e8ba3;
  
    --radius-sm: 6px;
    --radius-md: 10px;  /* chips a little less round */
    --shadow-1: 0 1px 6px rgba(0,0,0,.06);
    --shadow-2: 0 4px 14px rgba(0,0,0,.08);
  }

 


</style>
  
  <style scoped>

   /* Make the table slightly denser and fix column widths */
.table {
  table-layout: fixed;          /* respect explicit widths */
  font-size: 11px;              /* down from 12px */
}
.table thead th { 
  font-size: 11.5px;
  padding: 5px 6px;             /* a touch tighter */
}
.table tbody td {
  padding: 4px 6px;             /* a touch tighter */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Narrow the wordiest columns */
.col-client      { max-width: 160px; width: 160px; }
.col-origin      { max-width: 180px; width: 180px; }
.col-destination { max-width: 180px; width: 180px; }

/* Slightly tighten other cells so everything fits */
.table td:nth-child(1)  { width: 84px;  }  /* ID (badge) */
.table td:nth-child(2)  { width: 170px; }  /* Fecha y hora */
.table td:nth-child(6)  { width: 92px;  }  /* Hora inicio */
.table td:nth-child(7)  { width: 110px; }  /* Hora contacto */
.table td:nth-child(8)  { width: 80px;  }  /* Unidad */
.table td:nth-child(9)  { width: 110px; }  /* Operador */
.table td:nth-child(10) { width: 110px; }  /* Expediente */
.table td:nth-child(11) { width: 120px; }  /* Capturista */
.table td:nth-child(12) { width: 90px;  }  /* Tipo */
.table td:nth-child(13) { width: 110px; }  /* Estatus */

/* On slightly smaller screens, compress client/address a bit more */
@media (max-width: 1360px) {
  .col-client      { max-width: 140px; width: 140px; }
  .col-origin,
  .col-destination { max-width: 160px; width: 160px; }
}

/* On tighter layouts, shave a bit of font size and padding */
@media (max-width: 1200px) {
  .table { font-size: 10.5px; }
  .table thead th { font-size: 11px; }
  .table tbody td { padding: 3px 5px; }
}

  /* =========================
     Design tokens
  ========================= */
  
  /* Layout base */
  .orders-view {
    background: var(--bg);
    min-height: 100%;
  }
  
  /* Top bar */
  .nav-bar-operations {
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 56px;
    background: var(--brand);
    z-index: 1000;
    box-shadow: var(--shadow-1);
  }
  .logo-button {
    position: absolute; height: 80%;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer; margin: 0;
  }
  .top-spacer { height: 56px; }
  
  /* Header */
  .panel-head {
    margin: 10px 10px 8px;
    padding: 6px 8px;
    display: flex; align-items: center; justify-content: space-between;
  }
  .panel-head h3 {
    margin: 0;
    font-size: 14px;
    color: var(--text);
    letter-spacing: .2px;
  }
  .head-icon { width: 22px; height: 22px; opacity: .9; }
  
  /* Filters card */
  .filters-card {
    margin: 0 10px 10px;
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 8px;
    box-shadow: var(--shadow-1);
    padding: 8px;
    display: grid;
    grid-template-columns: 1fr;
    gap: 6px;
    font-size: 12px;
  }
  
  .filters-card .row {
    display: grid;
    grid-template-columns: 140px 320px 22px 320px;
    align-items: center;
    gap: 4px;
    min-height: 28px;
  }
  .filters-card .row.actions { grid-template-columns: 1fr; margin-top: 2px; }
  
  .filters-card label {
    color: var(--text);
    font-size: 12px;
    white-space: nowrap;
  }
  .filters-card .sep {
    text-align: center;
    color: var(--muted);
    font-size: 11px;
  }
  
  .filters-card input[type="text"],
  .filters-card input[type="date"],
  .filters-card select {
    height: 26px;
    padding: 0 8px;
    border: 1px solid #d2d2d2;
    border-radius: var(--radius-sm);
    font-size: 12px;
    outline: none;
    background: #fff;
  }
  .filters-card input::placeholder { color: #9aa0a6; font-size: 11px; }
  .filters-card input:focus,
  .filters-card select:focus {
    border-color: #bbb;
    box-shadow: 0 0 0 2px rgba(255,196,52,.22);
  }
  
  /* Suggestions */
  .row-rel { position: relative; }
  .suggestions {
    position: absolute;
    top: calc(26px + 4px);
    left: 140px;
    width: 320px;
    max-height: 220px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 8px;
    box-shadow: var(--shadow-2);
    list-style: none; margin: 0; padding: 4px 0; z-index: 10;
  }
  .suggestions li {
    padding: 6px 10px;
    font-size: 12px;
    cursor: pointer;
  }
  .suggestions li:hover { background: #f2f6ff; }
  
  /* Chips */
  .chips {
    grid-column: 2 / -1;
    display: flex; gap: 6px; flex-wrap: wrap;
  }
  .chip {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 4px 8px;
    border: 1px solid var(--border);
    border-radius: var(--radius-md); /* slightly less round */
    background: #fafafa;
    font-size: 11.5px;
    cursor: pointer;
    user-select: none;
  }
  .chip input { width: 14px; height: 14px; margin: 0; }
  .chip input:checked + span { font-weight: 600; }
  
  /* Buttons */
  .btn-primary {
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 8px;
    background: var(--brand);
    border: none; cursor: pointer;
    box-shadow: var(--shadow-1);
  }
  .btn-primary:hover { background: var(--brand-600); }
  
  /* Results card */
  .results-card {
    margin: 0 10px 16px;
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 8px;
    box-shadow: var(--shadow-1);
    overflow: hidden;
  }
  .results-head {
    padding: 8px 10px;
    border-bottom: 1px solid var(--border);
  }
  .results-head h2 {
    font-size: 14px; margin: 0; color: var(--text);
  }
  
  /* Table */
  .table-scroll { overflow-x: auto; }
  .table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    line-height: 1.15;
  }
  .table thead th {
    position: sticky; top: 0; z-index: 1;
    background: #f5f6f8;
    color: #475163;
    font-weight: 600;
    border-bottom: 1px solid var(--border);
    padding: 6px 8px;
    white-space: nowrap;
  }
  .table tbody td {
    padding: 5px 8px;
    border-bottom: 1px solid #f0f0f0;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .table tbody tr:nth-child(even) td { background: #fcfcfd; }
  .table tbody tr:hover td { background: #eef3ff; color: #0f172a; }
  .row-click { cursor: pointer; }
  
  /* Badges */
  .badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: var(--radius-sm);
    font-size: 11px;
    line-height: 1.3;
    border: 1px solid transparent;
  }
  .badge-id {
    background: var(--brand);
    color: #000;
    font-weight: 700;
    border: 1px solid #f0c35a;
  }
  .badge-success { background: var(--success); color: #fff; }
  .badge-assign  { background: var(--assign); color: #0f2a00; }
  .badge-danger  { background: var(--danger); color: #fff; }
  .badge-pending { background: var(--pending); color: #fff; }
  .badge-info    { background: var(--info); color: #fff; }
  .badge-neutral { background: var(--neutral); color: #fff; }
  
  /* Pagination */
  .pagination {
    display: flex; flex-wrap: wrap;
    justify-content: center; align-items: center;
    gap: 6px; padding: 10px;
    border-top: 1px solid var(--border);
  }
  .pg-btn {
    background: #fff; border: 1px solid var(--border);
    border-radius: 8px; padding: 2px 6px;
    cursor: pointer; box-shadow: var(--shadow-1);
  }
  .pg-btn:disabled { opacity: .5; cursor: not-allowed; }
  .pg-btn img { width: 18px; height: auto; display: block; }
  
  .pg-num {
    min-width: 28px; text-align: center;
    padding: 4px 8px; border-radius: 8px;
    border: 1px solid var(--border);
    background: #fff; cursor: pointer;
    user-select: none;
  }
  .pg-num.active {
    background: var(--brand);
    border-color: #e0b12b;
  }
  
  /* Utilities */
  .grayed-out { background: #f2f2f2; color: #999; }
  
  /* Responsive compression */
  @media (max-width: 1200px) {
    .filters-card .row {
      grid-template-columns: 120px minmax(180px,1fr) 18px minmax(180px,1fr);
    }
  }
  @media (max-width: 900px) {
    .filters-card .row { grid-template-columns: 120px 1fr; }
    .filters-card .sep, .filters-card .row > .cell { display: none; }
    .suggestions { left: 0; width: 100%; }
  }
  </style>
  